
import { apiProvider } from '@/core/api/'

export const initFilter = () => 
  apiProvider.get(`api/proposalrequestcontract/initfilters`);